import React from "react";
import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions,
  Button,
  useTheme,
  IconButton as MuiIconButton,
  Typography,
} from "@mui/material";
import CustomForm from "./CustomForm";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";

const DialogForm = ({
  fields,
  title,
  handleSubmit,
  open,
  setOpen,
  buttons,
  component,
  message,
  dialogWidth
}) => {
  const theme = useTheme();

  const Dialog = styled(MuiDialog)(({ theme, dialogWidth }) => ({
    "& .MuiPaper-root": {
      overflowX: "hidden",
      width: dialogWidth || "520px", // Use dialogWidth or fallback to 520px if falsy
      fontFamily: "Lato, sans-serif",
    },
  }));

  const DialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
    position: "relative",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontFamily: "Lato, sans-serif",
    fontWeight: 700,
    fontSize: "18px !important",
    lineHeight: "21.6px",
  }));

  const IconButton = styled(MuiIconButton)(({ theme }) => ({
    position: "absolute",
    right: 10,
    top: 8,
    color: "white",
  }));

  const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
    overflowX: "hidden",
    overflowY: "auto",
    padding: theme.spacing(2),
    fontFamily: "Lato, sans-serif",
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      scroll="body"
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      dialogWidth={dialogWidth} 
    >
      <DialogTitle
        sx={{
          backgroundColor: (theme) => theme.palette.primary.main, 
          color: (theme) => theme.palette.primary.contrastText, 
        }}
      >
        {title}
        <IconButton
          edge="end"
          color="primary"
          onClick={handleClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {message && (
        <Typography sx={{ marginLeft: "16px", mt: "16px" }}>
          {message}
        </Typography>
      )}
      <DialogContent sx={{ marginTop: "16px" }}>
        <CustomForm
          fields={fields}
          onSubmit={handleSubmit}
          buttons={buttons}
          component={component}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DialogForm;
